import { createSlice } from "@reduxjs/toolkit";


// Get user from localStorage
//const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_AUTH_USER))
////const org = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_AUTH_ORG))
// const page = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_AUTH_PAGE))



const initialState = {
	user : null ,
	org :  null , 

	 
}

export const authSlice = createSlice({
	name : "auth",
	initialState,
	reducers : {
		login : (state , action) => {
			 
			state.user = action.payload
			state.org = action.payload.organizations.find( x => x.is_default === true) ?? action.payload.organizations[0]
			 
		},
        updateUserMemberships : ( state , action ) => {
            state.user.memberships = action.payload 
        },
        updateUserOrganizations : ( state , action ) => {
            state.user.organizations = action.payload 
        },
        updateUserOrganizationByID : ( state , action ) => {
            const payload = action?.payload
            const organization_id = payload?.organization_id
            const data = payload?.data

            const index = state.user?.organizations?.findIndex( x => x.id === organization_id )
            state.user.organizations[index] = {
                ...state.user.organizations[index],
                ...data
            }
        },
        updateUserOrganizationPageByID : ( state , action ) => {
            const payload = action.payload ;
            const organization_id = payload.organization_id
            const data = payload?.data;
            const process_action = ['new', 'edit'].includes(payload.action) ? payload.action : 'edit'


            const organization_id_index = state.user.organizations.findIndex( x => x.id === organization_id )
            if(organization_id_index >=0 ) {

                if(process_action === 'new'){
                    state.user.organizations[organization_id_index].statuspages = [
                        ...state.user.organizations[organization_id_index].statuspages ?? [],
                        data
                    ]

                }else{

                    const statuspage_id_index = state.user.organizations[organization_id_index]?.statuspages.findIndex(x => x.id === payload.statuspage_id)
                    if(statuspage_id_index >=0 )
                        state.user.organizations[organization_id_index].statuspages[statuspage_id_index] = data
                }
            }
            
        },
        // SLICE : ORG 
        updateOrganization : (state , action ) => {
            const payload = action?.payload
            state.org = {
                ...state.org,
                ...payload
            }
        },
        updateOrganizationPages : ( state , action ) => {
            state.org.statuspages = action?.payload
        },
        updateOrganizationPagesByID : ( state , action ) => {
            const payload = action.payload;
            const statuspage_id_index = state.org?.statuspages.findIndex(x => x.id === payload.statuspage_id)
            if(statuspage_id_index >=0 )
                state.org.statuspages[statuspage_id_index] = payload?.data
            
        },
		reset: (state) => {
            state.user = null 
            state.org = null 
			
		},
	}
})
export const { reset , login , updateUserMemberships, updateUserOrganizations , updateOrganization , updateOrganizationPages,
    updateUserOrganizationPageByID, updateOrganizationPagesByID , updateUserOrganizationByID 
} = authSlice.actions
export default authSlice.reducer
